
import { EpimsBaseEntityDto } from './epim-base.dto';

export class CorrespondenceSingleActionDto extends EpimsBaseEntityDto {
  Title: string;
  Description: string;
  Status: string;
  CorrespondenceId: string;

}
